import { useSearchParams } from 'react-router'
import { Modal, ModalContent } from '@heroui/react'
import type { PbBranding } from '@itsrever/rever-api'
import { DemoSettingsForm } from './demo-settings-form'

interface DemoSettingsProps {
    onThemeUpdate: (theme: Partial<PbBranding>) => void
}

export const DemoSettings = ({ onThemeUpdate }: DemoSettingsProps) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const isDemo = searchParams.get('hacking-the-matrix') === 'true'

    return (
        <Modal
            isOpen={isDemo}
            onOpenChange={(open) => {
                if (!open) {
                    searchParams.delete('hacking-the-matrix')
                    setSearchParams(searchParams)
                }
            }}
            scrollBehavior="inside"
            className="rounded-md border border-solid border-neutral-200"
            backdrop="blur"
            classNames={{
                backdrop: 'backdrop-blur-sm'
            }}
        >
            <ModalContent>
                {(onClose) => (
                    <DemoSettingsForm
                        onClose={onClose}
                        onThemeUpdate={onThemeUpdate}
                    />
                )}
            </ModalContent>
        </Modal>
    )
}
